<template>
  <div>
    <template>
      <ul class="nav">
        <li :class="[lang]">{{ $t("orderInfo") }}</li>
      </ul>
    </template>
    <a-spin size="large" :spinning="loading">
      <div class="wrap-table">
        <a-table
          class="custom-scrollbar"
          size="middle"
          :columns="columns"
          :rowKey="(record, index) => index"
          :data-source="tableData"
          :pagination="false"
          :row-class-name="
            (_record, index) => (index % 2 !== 1 ? 'table-bg' : null)
          "
          :customRow="
            (record) => {
              return {
                on: {
                  click: () => goDetail(record),
                },
              };
            }
          "
        >
          <template slot="payType" slot-scope="text, record" class="arial">
            <span>{{
              record.duration_type == 2
                ? $t("AnnualPayment")
                : record.duration_type == 3
                ? $t("MonthlyPayment")
                : "免费"
            }}</span>
          </template>

          <template slot="action" slot-scope="text, record" class="arial">
            <template v-if="record.linkedin_id">
              <a-button
                v-if="record.linkedin_login == 0 && record.status != 3"
                type="primary"
                @click="continueSetp2(record)"
                size="small"
                style="height: 26px; font-size: 12px;margin-left: 10px;"
              >
                {{ $t("ContinueConnect") }}
              </a-button>
              <span v-if="record.linkedin_login != 0">{{ record.linkedin_email }}</span>
            </template>
            <a-button
              v-else-if="!(record.campaign_type == 0 && getEndTime) && record.status != 3"
              type="primary"
              @click="bindHandler(record)"
              size="small"
              style="height: 26px; font-size: 12px"
            >
              {{ $t("GotoLinkAccount") }}
            </a-button>
          </template>
        </a-table>
      </div>
    </a-spin>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMenu: true,
      tableData: [],
      loading: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.path == "/sales/salesReps/campaignDetail") {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
      console.log(to, from);
    },
    lang() {
      this.getData();
    },
  },
  computed: {
    currentPath: {
      get() {
        return this.$route.path;
      },
    },
    columns: {
      get() {
        let that = this;
        return [
          {
            title: that.$t("SubscriptionDate"),
            dataIndex: "create_date",
            align: "center",
            width: 200,
          },
          {
            title: that.$t("SubscriptionPlan"),
            dataIndex: "subscription_plan_name",
            align: "center",
          },
          {
            title: that.$t("PurchaseMethod"),
            dataIndex: "payment_method_name",
            align: "center",
          },
          {
            title: that.$t("SubscriptionType"),
            dataIndex: "duration_type",
            align: "center",
            // scopedSlots: {
            //   customRender: "payType",
            // },
          },
          {
            title: that.$t("Price"),
            dataIndex: "amount",
            align: "center",
            customRender: function (text, record) {
              return record.payment_method == 2 ? "-" : text;
            },
          },

          {
            title: that.$t("LinkAccount"),
            align: "center",
            fixed: "right",
            width: 200,
            scopedSlots: {
              customRender: "action",
            },
          },
        ];
      },
    },
    getEndTime () {
      let { end_date } = (this.user && this.user.free_info) || {}
      return Date.now() > new Date(end_date).getTime() // 过期
    }
  },
  i18n: require("../i18n"),
  created() {
    //this.showMenu = this.showMenu2();
    this.getData();
  },
  methods: {
    bindHandler(record) {
      console.log(record);
      let { id, campaign_type } = record;
      this.$router.push({
        path: "/setting/bindAccount",
        query: { id, campaign_type },
      });
    },
    getData() {
      this.loading = true;
      this.$axios("/payment/order_list", {}, "post").then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
        this.loading = false;
      });
    },
    goback() {
      this.$router.go(-1);
    },
    showMenu2() {
      if (this.$route.path == "/sales/salesReps/dialogue") {
        return false;
      } else if (this.$route.path == "/sales/salesReps/createCampaign") {
        return false;
      } else if (this.$route.path == "/sales/salesReps/campaignDetail") {
        return false;
      } else {
        return true;
      }
    },
    goDetail () {},
    // 继续进入 绑定linkindin 第二步
    continueSetp2 (record) {
      this.$router.push({
        path: "/setting/bindAccount",
        query: {
          id: record.id,
          campaign_type: record.campaign_type,
          timezone_config_id: record.timezone_config_id,
          country_config_id: record.country_config_id,
          linkedin_id: record.linkedin_id,
        },
      });
    }
  },
};
</script>
<style scoped lang="less">
.wrap-table {
  margin: 80px 30px 30px 30px;
  padding: 35px 30px 30px 30px;
  background: #fff;
  min-height: 690px;
}
.nav {
  width: 100%;
  padding-top: 7px;
  padding-left: 30px;
  border-top: #d1d1d1 solid 1px;
  li {
    height: 42px;
    line-height: 42px;
    padding: 0 12px;
    margin-right: 88px;
    display: inline-block;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    a {
      color: #000;
    }
    border-bottom: #fff 2px solid;
  }
  .selected {
    border-bottom: #0e756a 2px solid;
    a {
      font-weight: bold;
    }
  }
  background: #ffffff;
  box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
}
.nav,
.back {
  left: 254px;
  position: fixed;
  top: 64px;
  right: 0;
  z-index: 200;
}
.back {
  border-top: #d1d1d1 solid 1px;
  color: #0e756a;
  cursor: pointer;
  height: 50px;
  line-height: 50px;
  padding-left: 30px;
  background: #fff;
}
</style>
